import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../common/Navbar';
import Footer from '../common/Footer';
import useScrollToTop from '../../hooks/useScrollToTop';

const MainLayout: React.FC = () => {
  useScrollToTop();

  return (
    <div className="min-h-screen flex flex-col night-mode-bg">
      <Navbar />
      <main className="flex-grow pt-24">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout; 